
import { List, Typography, Divider } from 'antd';
import { Timeline } from 'antd';
import styles from "./styles.css";


const data = [
  'Racing car sprays burning fuel into crowd.',
  'Japanese princess to wed commoner.',
  'Australian walks 100km after outback crash.',
  'Man charged over missing wedding girl.',
  'Los Angeles battles huge wildfires.',
];


function About() {
  return (
    <div style={{textAlign : "center"}}>
      <div>
        <p className="about-title">About me</p>
      </div>

      <List
        style={{ display: "flex", justifyContent: "center"}}
        size="large"
        bordered
        dataSource={data}
        renderItem={item => <List.Item>{item}</List.Item>}
      />
    </div>
  );
}

export default About;
